export const commonState = {
  countries: [],
  allSites: [],
  selCountry: null
};
